import { useTranslation } from 'react-i18next';
import { ModalTemplate } from '../ModalTemplate';
import { HealthStatusIndicator } from 'components/HealthStatusIndicator';
import {
  HealthMachineInfoContainer, HealthStatusContainer, HealthStatusDescription, HealthStatusList, HealthStatusTitle,
} from './styles';
import { HealthStatus } from '~/pages/RemoteControl/MachineProfile/types';
import { t } from 'i18next';

interface HealthMachineInfoModalProps {
  healthStatus: HealthStatus;
  isOpen: boolean;
  onClose: () => void;
}

const infoHealthStatus: Record<HealthStatus, {
  description: string;
  technicalReport: string;
  causes: string[];
  title: string;
}> = {
  [HealthStatus.NO_ALERT]: {
    description: t('saudeMaquinaSemAlerta'),
    title: 'semAlerta',
    technicalReport: t('sistemaOperandoCorretamente'),
    causes: [],
  },
  [HealthStatus.ALERT]: {
    description: t('saudeMaquinaEmAlerta'),
    title: 'emAlerta',
    technicalReport: t('baixaTrocaCalorEvaporadoraRiscoCongelamento'),
    causes: [
      t('restricaoLinhaLiquido'),
      t('sujeiraEvaporadora'),
      t('falhaVentiladorEvaporadora'),
      t('cargaFluidoRefrigeranteInadequada'),
    ],
  },
  [HealthStatus.INOPERATIVE]: {
    description: t('saudeMaquinaInoperante'),
    title: 'inoperante',
    technicalReport: t('compressorInoperante'),
    causes: [
      t('baixaCargaFluidoRefrigerante'),
      t('dispositivoExpansaoDesregulado'),
      t('falhaEletrica'),
      t('falhaMecanica'),
    ],
  },
};

export const HealthMachineInfoModal: React.FC<HealthMachineInfoModalProps> = ({
  healthStatus,
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();
  const healthInfo = infoHealthStatus[healthStatus];

  return (
    <ModalTemplate
      padding={24}
      isOpen={isOpen}
      onClose={onClose}
      centralizedText
      iconTitle={<HealthStatusIndicator status={healthStatus} />}
      imageText={(
        <HealthMachineInfoContainer>
          <HealthStatusModal
            description={healthInfo.description}
            technicalReport={healthInfo.technicalReport}
            causes={healthInfo.causes}
          />
        </HealthMachineInfoContainer>
      )}
      title={t(healthInfo.title)}
      button1={t('fechar')}
      button1Action={onClose}
      dataTestId="modal-health-status-info"
    />
  );
};

function HealthStatusModal(params: {description: string, technicalReport: string, causes: string[] }): JSX.Element {
  return (
    <HealthStatusContainer>
      <HealthStatusDescription>{params.description}</HealthStatusDescription>
      <div>
        <HealthStatusTitle>{t('laudoTecnico')}</HealthStatusTitle>
        <HealthStatusDescription>{params.technicalReport}</HealthStatusDescription>
      </div>
      { params.causes.length > 0 && (
      <div>
        <HealthStatusTitle>
          {t('possiveisCausas')}
          :
        </HealthStatusTitle>
        <HealthStatusList>
          {params.causes.map((c) => <li key={c}>{c}</li>)}
        </HealthStatusList>
      </div>
      )}
    </HealthStatusContainer>
  );
}
